export default "__VITE_ASSET__CRLSg0iE__"